import { Question } from "@phosphor-icons/react";

/**
 * The only explanation a heading may carry, design.md section 3, rule 3: one line behind a question
 * mark. A `details` element, so it opens by keyboard and by touch without script, and the line is in
 * the document for a screen reader whether it is open or not.
 */
export function Hint({ children, label = "Vad betyder det här?" }: { children: string; label?: string }) {
  return (
    <details className="hint">
      <summary aria-label={label}>
        <Question size={17} aria-hidden="true" />
      </summary>
      <span>{children}</span>
    </details>
  );
}
